import { CSSProperties } from 'react';
import { Colors } from '../../../common/Colors';
import { Variables } from '../../../common/Variables';

interface Config {
  isHintAtBottom: boolean;
}

export const getCustomStyles: any = ({ isHintAtBottom }: Config) => ({
  control: (provided: CSSProperties, state: any) => ({
    ...provided,
    overflow: 'hidden',
    flexWrap: 'nowrap',
    alignItems: 'center',
    height: '5rem',
    minHeight: 'auto',
    lineHeight: 'inherit',
    fontSize: '1.4rem',
    backgroundColor: state.isFocused ? Colors.ut.inputUp : Colors.ut.input,
    borderRadius: Variables.inputRadius,
    borderWidth: 0,
    boxShadow: 'none',
    transition: 'background-color 0.25s, color 0.25s',

    ...(isHintAtBottom
      ? {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      : {}),

    '&:hover': {
      backgroundColor: state.isFocused ? Colors.ut.inputDown : Colors.ut.inputUp
    }
  }),

  input: () => ({
    position: 'relative',
    padding: '0 1.9rem 0 0.9rem',

    input: {
      lineHeight: 'inherit',
      '&::placeholder': {
        color: Colors.text.disabled,
        opacity: 1
      }
    }
  }),

  valueContainer: () => ({
    overflow: 'hidden',
    maxWidth: 'none',
    marginLeft: 0,
    marginRight: 0,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    display: 'flex',
    transform: 'none',
    position: 'relative',
    flexGrow: 1,

    '&:after': {
      content: '" "',
      display: 'inline',
      whiteSpace: 'pre'
    }
  }),

  singleValue: (provided: CSSProperties) => ({
    ...provided,
    position: 'relative',
    transform: 'none',
    maxWidth: 'calc(100% - 2.5rem)',
    padding: '0 1.9rem 0 0.9rem',
    margin: 0,
    color: Colors.text.default
  }),

  placeholder: (provided: CSSProperties) => ({
    ...provided,
    position: 'relative',
    transform: 'none',
    top: 'none',
    paddingLeft: '1.6rem',
    minWidth: '11rem',
    maxWidth: '15rem',
    margin: 0,
    color: Colors.text.defaultDim
  }),

  menu: (provided: CSSProperties) => ({
    ...provided,
    zIndex: 500,
    top: '100%',
    margin: 0,
    backgroundColor: Colors.text.inverse,
    borderRadius: Variables.tooltipRadius,
    boxShadow: `0 0 0 1px ${Colors.ut.border5}, 0 0.7rem 1rem ${Colors.ut.border10}`
  }),

  menuList: (provided: CSSProperties) => ({
    ...provided,
    padding: 0,
    borderRadius: 'inherit'
  }),

  option: (provided: CSSProperties, state: any) => ({
    cursor: 'default',
    display: 'flex',
    alignItems: 'center',
    padding: '1.1rem 2rem',
    fontSize: '1.4rem',
    lineHeight: 1.2,
    textAlign: 'left',
    color: state.isSelected && Colors.text.default,
    backgroundColor:
      (state.isSelected && Colors.ut.primaryDim) || (state.isFocused && Colors.ut.border5),
    transition: `background-color ${state.isFocused ? '0.1s ease-out' : '0.3s ease-in'}`,

    '&:focus': {
      outline: 0
    },

    '&:active': {
      backgroundColor: Colors.ut.border10
    }
  }),

  noOptionsMessage: (provided: CSSProperties) => ({
    ...provided,
    color: Colors.text.defaultDim
  }),

  multiValue: () => ({
    display: 'inline',

    '&:not(:last-of-type):after': {
      content: '", "',
      display: 'inline'
    }
  }),

  multiValueLabel: () => ({
    display: 'inline'
  }),

  indicatorsContainer: (provided: CSSProperties) => ({
    ...provided,
    position: 'relative',
    flexShrink: 0
  })
});
